import { FC, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  className?: string;
}

const Portal: FC<PortalProps> = ({ className = '', children }) => {
  const [container] = useState<HTMLDivElement>(() => {
    const element = document.createElement('div');
    element.className = className;

    return element;
  });

  const [mountNode, setMountNode] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    const portalRoot = document.getElementById('portal-root');

    if (!portalRoot) {
      return undefined;
    }

    portalRoot.appendChild(container);
    setMountNode(container);

    return () => {
      if (portalRoot.contains(container)) {
        portalRoot.removeChild(container);
      }

      setMountNode(null);
    };
  }, [container]);

  if (!mountNode) {
    return null;
  }

  return createPortal(children, mountNode);
};

export default Portal;
